import type { StepConfigFor } from '../getStepConfig.types.ts';

export const MessageStepConfig = {
  statuses: {
    NOT_STARTED: {
      label: 'Message Required',
      cta: 'Send Message',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? `The patient is tasked with sending a message to us in the specified chat`
          : 'Please provide us with some more information',
    },

    PENDING: {
      label: 'Message Received',
      cta: 'Message Again',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has sent a message to us. We need to review it and update the status'
          : 'Your message has been received and is being reviewed. We will update you shortly',
    },

    COMPLETED: {
      label: 'Resolved',
      cta: 'View',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has successfully sent a message to us. We have reviewed it and resolved the issue'
          : 'Your message has been reviewed and resolved',
    },

    ERROR: {
      label: 'Additional Information Required',
      cta: 'Send Message Again',
      context: ({ isHealthcareProvider }) =>
        isHealthcareProvider
          ? 'The patient has not provided the additional information required. We need to request it again'
          : 'We need additional information from you. Please provide it in the chat',
    },
  },
} satisfies StepConfigFor<'MESSAGE'>;
